import classNames from 'classnames'

import { Button, BUTTON_SIZE, BUTTON_TYPES } from '../button'

import styles from './productCTA.module.scss'
interface DisplayButtonType {
  onClick: () => void
  className?: string
  showLoader?: boolean
  selectorKey?: string
  children?: string
  buttonRef?: any
  disabled?: boolean
  buttonType?: BUTTON_TYPES
  showNewPdpUI?: boolean
  buttonSize?: BUTTON_SIZE
  showNewPdpDesignV2?: boolean
}
export const ProductDisplayButton = ({
  children,
  onClick,
  className,
  showLoader,
  selectorKey,
  buttonRef,
  disabled = false,
  buttonType = BUTTON_TYPES.PRIMARY,
  showNewPdpUI = false,
  buttonSize = BUTTON_SIZE.LARGE,
  showNewPdpDesignV2,
}: DisplayButtonType) => {
  return (
    <Button
      className={classNames(
        styles.displayButtonWrapper,
        className,
        disabled && styles.productCTADisabled,
        showNewPdpUI && styles.displayButtonWrapper_adjustedPadding,
        showNewPdpDesignV2 && styles.displayButtonWrapper_newDesignV2,
      )}
      type={buttonType}
      size={buttonSize}
      disabled={disabled}
      round={true}
      onClick={onClick}
      showLoader={showLoader}
      selectorKey={selectorKey}
      buttonRef={buttonRef}
    >
      {children}
    </Button>
  )
}
